__webpack_require__.p = "/my-slider-app/";